import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-corporate-cards.component.scss';
var FormItemCorporateCards = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemCorporateCards, _super);
    function FormItemCorporateCards(element) {
        return _super.call(this, element) || this;
    }
    FormItemCorporateCards.prototype.init = function () {
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formFields = this.element.querySelector(".form__fields--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.form = this.element.querySelector("form");
        this.formWizard = this.element.querySelector(".form-item-corporate-cards__wizard");
        this.formQuestionnaire = this.element.querySelector(".form-item-corporate-cards__questionnaire");
        this.startButton = this.element.querySelector(".form-item-corporate-cards__start-btn");
        this.buttonSubmit = this.element.querySelector(".js-corporate__button--submit");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.businessAccount = Array.from(this.form.querySelectorAll("input[name=business-account]"));
        this.businessAccountHeld = this.form.querySelector("select[name=business-account-held-with]");
        this.entityType = this.form.querySelector("select[name=entity-type]");
        this.marriageStatusSelect = this.form.querySelector("select[name=marital-status]");
        this.marriageStatus = this.form.querySelector(".marriage-status");
        this.marriageType = this.form.querySelector(".marriage-type");
        if (this.marriageType) {
            this.marriageTypeInputs = Array.from(this.marriageType.querySelectorAll("input[type=radio]"));
        }
        this.marriageConsent = this.form.querySelector(".marriage-consent");
        this.businessName = this.form.querySelector(".business-name");
        this.businessReg = this.form.querySelector(".business-registration");
        this.saId = this.form.querySelector("input[name=sa-id]");
        this.sourceOfFunds = this.form.querySelector("select[name=source-of-funds]");
        this.updateForms();
    };
    FormItemCorporateCards.prototype.bindEvents = function () {
        var _this = this;
        if (this.startButton) {
            this.startButton.addEventListener("click", function (pEvent) {
                _this.showForm();
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (pEvent) {
                _this.updateForms(pEvent, "entity");
            });
        }
        if (this.marriageStatus) {
            this.marriageStatus.addEventListener("change", function (pEvent) {
                _this.updateForms(pEvent, "status");
            });
        }
        if (this.marriageTypeInputs) {
            this.marriageTypeInputs.map(function (item) { return item.addEventListener("click", function (pEvent) {
                _this.updateForms(pEvent, "type");
            }); });
        }
        if (this.agreement) {
            this.agreement.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                if (evt.value === "no") {
                    _this.applicationUnSuccessful();
                }
            }); });
        }
        if (this.businessAccount) {
            this.businessAccount.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                var hasExistingBusAcc = evt.value;
                if (_this.businessAccountHeld) {
                    _this.updateBusinessAccountHeld(hasExistingBusAcc);
                }
            }); });
        }
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                _this.validateSourceOfFunds();
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        }
        if (this.businessReg) {
            var _busRegInput = this.businessReg.querySelector("input[name=business-registration]");
            _busRegInput.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            _busRegInput.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            _this.form.reset();
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            _this.updateForms();
            _this.updateBusinessAccountHeld("NO");
            if (_this.formWizard) {
                _this.formWizard.classList.add("form-item-corporate-cards--hidden");
            }
            if (_this.formQuestionnaire) {
                _this.formQuestionnaire.classList.remove("form-item-corporate-cards--hidden");
            }
            var _name = Array.from(_this.element.querySelectorAll(".form__success-container__firstname"));
            if (_name) {
                _name.map(function (_item) {
                    _item.innerHTML = "";
                });
            }
            var _title = Array.from(_this.element.querySelectorAll(".form__success-container__title"));
            if (_title) {
                _title.map(function (_item) {
                    _item.innerHTML = "";
                });
            }
        }, false);
    };
    FormItemCorporateCards.prototype.updateBusinessAccountHeld = function (hasExistingBusAcc) {
        if (hasExistingBusAcc === "YES") {
            var businessAccountHeldGroup = this.businessAccountHeld.closest(".form__group");
            businessAccountHeldGroup.classList.add("form__group--hidden");
        }
        else {
            var businessAccountHeldGroup = this.businessAccountHeld.closest(".form__group");
            businessAccountHeldGroup.classList.remove("form__group--hidden");
        }
    };
    FormItemCorporateCards.prototype.showForm = function () {
        var valid = [];
        var yesAnswers = [];
        var businessRescue = this.form.querySelector("input[name=business-rescue]");
        if (businessRescue) {
            var businessRescueChecked = this.form.querySelector("input[name=business-rescue]:checked");
            if (!businessRescueChecked) {
                valid.push("false");
                this.validationService.addError(businessRescue, ["This field is required"]);
            }
            else if (businessRescueChecked.value === "YES") {
                yesAnswers.push("true");
            }
        }
        var liquidation = this.form.querySelector("input[name=liquidation]");
        if (liquidation) {
            var liquidationChecked = this.form.querySelector("input[name=liquidation]:checked");
            if (!liquidationChecked) {
                valid.push("false");
                this.validationService.addError(liquidation, ["This field is required"]);
            }
            else if (liquidationChecked.value === "YES") {
                yesAnswers.push("true");
            }
        }
        var sequestration = this.form.querySelector("input[name=sequestration]");
        if (sequestration) {
            var sequestrationChecked = this.form.querySelector("input[name=sequestration]:checked");
            if (!sequestrationChecked) {
                valid.push("false");
                this.validationService.addError(sequestration, ["This field is required"]);
            }
            else if (sequestrationChecked.value === "YES") {
                yesAnswers.push("true");
            }
        }
        var debtReview = this.form.querySelector("input[name=debt-review]");
        if (debtReview) {
            var debtReviewChecked = this.form.querySelector("input[name=debt-review]:checked");
            if (!debtReviewChecked) {
                valid.push("false");
                this.validationService.addError(debtReview, ["This field is required"]);
            }
            else if (debtReviewChecked.value === "YES") {
                yesAnswers.push("true");
            }
        }
        var adminOrder = this.form.querySelector("input[name=administration-order]");
        if (adminOrder) {
            var adminOrderChecked = this.form.querySelector("input[name=administration-order]:checked");
            if (!adminOrderChecked) {
                valid.push("false");
                this.validationService.addError(adminOrder, ["This field is required"]);
            }
            else if (adminOrderChecked.value === "YES") {
                yesAnswers.push("true");
            }
        }
        var consent = this.form.querySelector("input[name=fraud-and-credit-consent]");
        if (consent) {
            if (!consent.checked) {
                valid.push("false");
                this.validationService.addError(consent, ["This field is required"]);
            }
        }
        if ((valid.length === 0) && (yesAnswers.length === 0)) {
            if (this.formQuestionnaire) {
                this.formQuestionnaire.classList.add("form-item-corporate-cards--hidden");
            }
            if (this.formWizard) {
                this.formWizard.classList.remove("form-item-corporate-cards--hidden");
            }
        }
        else if (yesAnswers.length > 0) {
            this.showFailed();
        }
    };
    FormItemCorporateCards.prototype.showFailed = function (pName) {
        if (pName === void 0) { pName = null; }
        if (this.formFields) {
            this.formFields.classList.add("hidden");
            if (this.formThankyou) {
                this.formThankyou.classList.add("active");
                var _successContainer = this.form.querySelector(".form__success--container");
                _successContainer.classList.remove("active");
                _successContainer.classList.add("hidden");
                var _errorContainer = this.form.querySelector(".form__error--container");
                _errorContainer.classList.remove("active");
                _errorContainer.classList.add("hidden");
                var _failContainer = this.form.querySelector(".form__declined--container");
                _failContainer.classList.add("active");
                _failContainer.classList.remove("hidden");
                if (pName) {
                    var _name = _failContainer.querySelector(".form__success-container__firstname");
                    var _title = _failContainer.querySelector(".form__success-container__title");
                    if (_name) {
                        _name.innerHTML = "Thank you, " + pName;
                        if (_title) {
                            _title.innerHTML = "Unfortunately you can not proceed with this application as you require consent from your spouse.";
                        }
                    }
                }
            }
        }
    };
    FormItemCorporateCards.prototype.updateForms = function (pEvent, pType) {
        if (pEvent === void 0) { pEvent = null; }
        if (pType === void 0) { pType = null; }
        var value = "";
        if (pEvent) {
            value = pEvent.target.value;
        }
        if (pType && pType === "entity") {
            if (value === "Sole Proprietor") {
                this.marriageStatus.classList.remove("form__group--hidden");
            }
            else {
                this.marriageStatusSelect.value = "";
                this.marriageTypeInputs.forEach(function (element) {
                    element.checked = (element.value === "NO") ? true : false;
                });
                this.marriageStatus.classList.add("form__group--hidden");
                this.marriageType.classList.add("form__group--hidden");
                this.marriageConsent.classList.add("form__group--hidden");
            }
        }
        if (pType && pType === "status") {
            if (value === "Married") {
                this.marriageType.classList.remove("form__group--hidden");
            }
            else {
                this.marriageTypeInputs.forEach(function (element) {
                    element.checked = (element.value === "NO") ? true : false;
                });
                this.marriageType.classList.add("form__group--hidden");
                this.marriageConsent.classList.add("form__group--hidden");
            }
        }
        if (pType && pType === "type") {
            if (value === "YES") {
                this.marriageConsent.classList.remove("form__group--hidden");
            }
            else {
                this.marriageConsent.classList.add("form__group--hidden");
            }
        }
        if ((pType === "" || pType === null) && this.marriageStatus && this.marriageType && this.marriageConsent) {
            this.marriageStatusSelect.value = "";
            this.marriageTypeInputs.forEach(function (element) {
                element.checked = (element.value === "NO") ? true : false;
            });
            this.marriageStatus.classList.add("form__group--hidden");
            this.marriageType.classList.add("form__group--hidden");
            this.marriageConsent.classList.add("form__group--hidden");
        }
        if (this.entityType && this.saId && this.businessReg) {
            if (this.entityType.value === "Sole Proprietor") {
                this.businessName.classList.add("form__group--hidden");
                this.businessReg.classList.add("form__group--hidden");
            }
            else {
                this.businessName.classList.remove("form__group--hidden");
                this.businessReg.classList.remove("form__group--hidden");
            }
        }
    };
    FormItemCorporateCards.prototype.applicationUnSuccessful = function () {
        var fieldsContainer = this.element.querySelector(".form__fields--container");
        fieldsContainer.classList.add("hidden");
        this.formThankyou.classList.add("active");
        var unsuccessful = this.element.querySelector(".form__unsuccessful--container");
        var success = this.element.querySelector(".form__success--container");
        unsuccessful.classList.add("active");
        success.classList.add("hidden");
    };
    FormItemCorporateCards.prototype.validateSourceOfFunds = function () {
        var sourceOfFundsGroup = this.sourceOfFunds.closest(".form__group");
        var isValid = true;
        var selected = "";
        for (var i = 0; i < this.sourceOfFunds.options.length; i++) {
            if (this.sourceOfFunds.options[i].selected) {
                selected += this.sourceOfFunds.options[i].value + "";
            }
            if (selected !== "") {
                break;
            }
        }
        if (selected === "") {
            isValid = false;
        }
        if (isValid) {
            sourceOfFundsGroup.classList.remove("form__group--error");
            var _errorDiv = sourceOfFundsGroup.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
        }
        else {
            sourceOfFundsGroup.classList.add("form__group--error");
            var _errorDiv = document.createElement("div");
            _errorDiv.classList.add("form__group--error_message");
            var _errors = document.createElement("ul");
            var _error = document.createElement("li");
            _error.innerHTML = "This field is required";
            _errors.appendChild(_error);
            _errorDiv.appendChild(_errors);
            sourceOfFundsGroup.appendChild(_errorDiv);
        }
    };
    FormItemCorporateCards.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var declined = this.form.querySelector(".form__declined--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var unsuccessful = this.element.querySelector(".form__unsuccessful--container");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        // variables
        var _email = form.querySelector("input[name=email]");
        var _description = form.querySelector("input[name=description]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _businessAccount = this.form.querySelector("input[name=business-account]:checked");
        var _businessAccountHeldWith = this.form.querySelector("select[name=business-account-held-with]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _alternativeContactNumber = this.form.querySelector("input[name=alternative-contact-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _southAfricanId = this.form.querySelector("input[name=sa-id]");
        var _monthlyGrossIncome = this.form.querySelector("input[name=monthly-gross-income]");
        var _monthlyExpenses = this.form.querySelector("input[name=monthly-expenses]");
        var _consent = this.form.querySelector("input[name=consent]");
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _maritalStatus = this.form.querySelector("select[name=marital-status]");
        var _marriedType = this.form.querySelector("input[name=married-cop]:checked");
        var _marriedConsent = this.form.querySelector("input[name=written-consent]:checked");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _businessRegNumber = this.form.querySelector("input[name=business-registration]");
        var _financialYearEnd = this.form.querySelector("select[name=financial-year-end]");
        var _requestedCreditLimit = this.form.querySelector("input[name=requested-credit-limit]");
        var _intention = this.form.querySelector("input[name=use-of-funds]");
        var _businessMonthlyIncome = this.form.querySelector("input[name=business-monthly-income]");
        var _businessMonthlyExpenses = this.form.querySelector("input[name=business-monthly-expenses]");
        var _sourceOfFunds = this.form.querySelector("select[name=source-of-funds]");
        if (_marriedConsent) {
            if ((_marriedType.value === "YES") && (_marriedConsent.value === "NO")) {
                this.showFailed(_firstname.value);
                return null;
            }
        }
        var options = "";
        if (_sourceOfFunds) {
            for (var i = 0; i < _sourceOfFunds.options.length; i++) {
                if (_sourceOfFunds.options[i].selected) {
                    if (options === "") {
                        if (_sourceOfFunds.options[i].value !== "") {
                            options += _sourceOfFunds.options[i].value;
                        }
                    }
                    else {
                        if (_sourceOfFunds.options[i].value !== "") {
                            options += "," + _sourceOfFunds.options[i].value;
                        }
                    }
                }
            }
        }
        var _sourceOfFundsValue = this.form.querySelector("input[name=source-funds-value]");
        var _postData = {
            'email': (_email ? _email.value : ""),
            'description': (_description ? _description.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'businessAccount': (_businessAccount ? _businessAccount.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'businessAccountHeldWith': (_businessAccountHeldWith ? (_businessAccount.value === "NO" ? _businessAccountHeldWith.value : "") : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNumber': (_contactNumber ? _contactNumber.value : ""),
            'alternateContactNumber': (_alternativeContactNumber ? _alternativeContactNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'said': (_southAfricanId ? _southAfricanId.value : ""),
            'monthlyGrossIncome': (_monthlyGrossIncome ? _monthlyGrossIncome.value : ""),
            'monthlyExpenses': (_monthlyExpenses ? _monthlyExpenses.value : ""),
            'personalInformationConsent': (_consent ? (_consent.checked ? "YES" : "NO") : ""),
            'entityType': (_entityType ? _entityType.value : ""),
            'maritalStatus': (_maritalStatus ? _maritalStatus.value : ""),
            'marriedInCommunityOfProperty': (_marriedType ? _marriedType.value : ""),
            'writtenConsent': (_marriedConsent ? _marriedConsent.value : "NO"),
            'businessName': (_businessName ? _businessName.value : ""),
            'businessRegistration': (_businessRegNumber ? _businessRegNumber.value : ""),
            'financialYearEnd': (_financialYearEnd ? _financialYearEnd.value : ""),
            'requestedCreditLimit': (_requestedCreditLimit ? _requestedCreditLimit.value : ""),
            'useOfFunds': (_intention ? _intention.value : ""),
            'businessMonthlyIncome': (_businessMonthlyIncome ? _businessMonthlyIncome.value : ""),
            'businessMonthlyExpenses': (_businessMonthlyExpenses ? _businessMonthlyExpenses.value : ""),
            'sourceOfFunds': options,
            'sourceOfFundsValue': (_sourceOfFundsValue ? _sourceOfFundsValue.value : "")
        };
        // loader + hide form
        this.formLoader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = this.baseUrl + "/services/CompanyCardsForm.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            _this.formLoader.classList.remove("active");
            if (!pResponse.data) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
                _this.formThankyou.classList.add("active");
                error.classList.remove("hidden");
                error.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
            else if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.formThankyou.classList.add("active");
                error.classList.remove("hidden");
                error.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
            else {
                name.map(function (_item) {
                    _item.innerHTML = _firstname.value;
                });
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.formThankyou.classList.add("active");
                success.classList.add("active");
                success.classList.remove("hidden");
                error.classList.remove("active");
                error.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
            _this.formLoader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
            _this.formThankyou.classList.add("active");
            error.classList.remove("hidden");
            error.classList.add("active");
            success.classList.remove("active");
            success.classList.add("hidden");
            declined.classList.remove("active");
            declined.classList.add("hidden");
        });
    };
    return FormItemCorporateCards;
}(Base));
export { FormItemCorporateCards };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-corporate-cards/form-item-corporate-cards.component.ts
// module id = 885
// module chunks = 0